<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class BaseBanner extends Vue {
  constructor() {
    super()
  }
}
</script>

<template>
  <v-alert class="base-banner" dense>
    <slot></slot>
  </v-alert>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.base-banner {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 17px;
  letter-spacing: 0.5px;
}
</style>
